module.exports = __webpack_public_path__ + "img/nitja-corelogo-500px.13a5e3a5.svg";